"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4764],{

/***/ 84764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ hubspot_form_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/hubspot-contact-form/hubspot-contact-form.js + 1 modules
var hubspot_contact_form = __webpack_require__(78160);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-form/hubspot-form-component.scss.js


var MAX_DESKTOP_CONTENT_WIDTH_PX = "".concat(vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px");
var MAX_MOBILE_CONTENT_WIDTH_PX = "".concat(vp_sizes/* XS_M */.g4, "px");
var StyledHubspotFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1oec2090"
})("	margin:", function(param) {
    var horizontalMargin = param.horizontalMargin;
    return horizontalMargin ? "0 ".concat(horizontalMargin) : "auto";
}, ";max-width:", function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth;
}, ";.hubspot-contact-form-wrapper{.base-form{box-shadow:", function(param) {
    var disableShadow = param.disableShadow;
    return disableShadow && "none";
}, ";.contact-form-row{text-align:left;}.generic-form-input-component .form-input-wrapper{margin-bottom:24px;}}}@media (max-width:", MAX_DESKTOP_CONTENT_WIDTH_PX, "){.base-form .contact-form-row{flex-direction:unset;}}@media (max-width:", MAX_MOBILE_CONTENT_WIDTH_PX, "){.base-form{padding-left:", function(param) {
    var mobileHorizontalPadding = param.mobileHorizontalPadding;
    return mobileHorizontalPadding;
}, ";padding-right:", function(param) {
    var mobileHorizontalPadding = param.mobileHorizontalPadding;
    return mobileHorizontalPadding;
}, ";.contact-form-row .form-input-wrapper{font-size:0.8125rem;}}}", function(param) {
    var singleLineFieldBreakpoint = param.singleLineFieldBreakpoint;
    return singleLineFieldBreakpoint ? "\n        @media (max-width: ".concat(singleLineFieldBreakpoint, "px) {\n          .base-form .contact-form-row {\n            flex-direction: column;\n            align-items: baseline;\n\n            .form-input-wrapper {\n              width: 100%;\n            }\n          }\n        }\n      ") : "";
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-form/hubspot-form-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var HubspotFormComponent = function(_param) {
    var formId = _param.formId, disableShadow = _param.disableShadow, horizontalMargin = _param.horizontalMargin, maxWidth = _param.maxWidth, ctaProps = _param.ctaProps, mobileHorizontalPadding = _param.mobileHorizontalPadding, privacyNoticeText = _param.privacyNoticeText, singleLineFieldBreakpoint = _param.singleLineFieldBreakpoint, props = _object_without_properties(_param, [
        "formId",
        "disableShadow",
        "horizontalMargin",
        "maxWidth",
        "ctaProps",
        "mobileHorizontalPadding",
        "privacyNoticeText",
        "singleLineFieldBreakpoint"
    ]);
    var getFormId = function() {
        return formId || contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD;
    };
    var validScreenWidthForSingleLineField = (0,react.useMemo)(function() {
        return parseInt(singleLineFieldBreakpoint, 10) || null;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHubspotFormComponent, {
        className: "hubspot-form-component",
        maxWidth: maxWidth,
        mobileHorizontalPadding: mobileHorizontalPadding,
        singleLineFieldBreakpoint: validScreenWidthForSingleLineField,
        horizontalMargin: horizontalMargin,
        disableShadow: disableShadow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hubspot_contact_form/* default */.Z, _object_spread({
            isV2: true,
            formId: getFormId(),
            ctaProps: ctaProps,
            privacyNoticeText: privacyNoticeText
        }, props))
    });
};
/* harmony default export */ var hubspot_form_component = (HubspotFormComponent);


/***/ })

}]);